var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconBolt = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 24,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4825 11.3493C17.5719 11.204 17.6209 11.0374 17.6245 10.8669C17.6281 10.6963 17.5861 10.5279 17.5029 10.379C17.4197 10.2301 17.2983 10.106 17.1512 10.0197C17.004 9.93331 16.8366 9.88775 16.666 9.8877H13.4063V1.4502L6.51753 12.6458C6.42807 12.791 6.37901 12.9575 6.3754 13.128C6.37179 13.2986 6.41377 13.467 6.497 13.6159C6.58023 13.7647 6.7017 13.8887 6.84885 13.9749C6.99601 14.0612 7.16352 14.1066 7.33409 14.1064H10.5938V22.5439L17.4825 11.3493Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 24,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.4825 11.3493C17.5719 11.204 17.6209 11.0374 17.6245 10.8669C17.6281 10.6963 17.5861 10.5279 17.5029 10.379C17.4197 10.2301 17.2983 10.106 17.1512 10.0197C17.004 9.93331 16.8366 9.88775 16.666 9.8877H13.4063V1.4502L6.51753 12.6458C6.42807 12.791 6.37901 12.9575 6.3754 13.128C6.37179 13.2986 6.41377 13.467 6.497 13.6159C6.58023 13.7647 6.7017 13.8887 6.84885 13.9749C6.99601 14.0612 7.16352 14.1066 7.33409 14.1064H10.5938V22.5439L17.4825 11.3493Z",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
});
export default SvgIconBolt;
export const raw = __webpack_public_path__ + "static/media/icon-bolt.af7af8c1e775c0f0f83bd45add49230a.svg";